import React, { useState } from 'react';
import { toast } from 'sonner';

const Field = ({ value, onSave, testId, placeholder, wide }) => {
  const [v, setV] = useState(value || '');
  return (
    <input data-testid={testId} value={v} placeholder={placeholder}
      onChange={e => setV(e.target.value)} onBlur={() => v !== (value || '') && onSave(v)}
      className={`border border-slate-200 rounded px-2 py-1 text-xs focus:border-[#316536] outline-none ${wide ? 'w-full' : 'w-36'}`} />
  );
};

const GroupRow = ({ g, save }) => (
  <tr className={`border-t ${g.show ? '' : 'bg-slate-50 text-slate-400'}`} data-testid={`bullet-group-row-${g.code}`}>
    <td className="px-2 py-1.5 font-mono text-[11px] font-bold">{g.code}</td>
    <td className="px-2 py-1.5 text-xs">{g.title}</td>
    <td className="px-2 py-1.5"><Field wide value={g.template} testId={`bullet-template-${g.code}`} onSave={v => save(g, { template: v })} /></td>
    <td className="px-2 py-1.5"><Field wide value={g.template_reroof} placeholder="(same as left)" testId={`bullet-template-reroof-${g.code}`} onSave={v => save(g, { template_reroof: v })} /></td>
    <td className="px-2 py-1.5"><Field value={g.short_tag} testId={`bullet-short-${g.code}`} onSave={v => save(g, { short_tag: v })} /></td>
    <td className="px-2 py-1.5 text-xs">{g.unit || '—'}</td>
    <td className="px-2 py-1.5 text-center">
      <input type="checkbox" checked={!!g.show} data-testid={`bullet-show-${g.code}`} onChange={e => save(g, { show: e.target.checked })} />
    </td>
  </tr>
);

export const WordingTab = ({ api, groups, tokens, onSaved }) => {
  const save = async (g, patch) => {
    try { await api.put(`/bullet-groups/${g.code}`, patch); toast.success(`${g.code} saved`); onSaved(); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Save failed'); }
  };
  return (
    <div className="space-y-4" data-testid="bullet-wording-tab">
      <div className="bg-white border border-slate-200 rounded-md overflow-x-auto">
        <table className="w-full text-left">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500">
            <tr><th className="px-2 py-2">Code</th><th className="px-2 py-2">Group</th><th className="px-2 py-2">Wording (Repairs / default)</th>
              <th className="px-2 py-2">Wording (Re-Roof)</th><th className="px-2 py-2">Short tag (13+ bullets)</th><th className="px-2 py-2">Unit</th><th className="px-2 py-2">Show</th></tr>
          </thead>
          <tbody>{groups.map(g => <GroupRow key={`${g.code}-${g.updated_at || ''}`} g={g} save={save} />)}</tbody>
        </table>
      </div>
      <div className="bg-white border border-slate-200 rounded-md p-3" data-testid="bullet-token-list">
        <h3 className="text-xs font-bold uppercase tracking-wider text-slate-600 mb-2">Bullet tokens (also in Token Registry → "Bullet tokens")</h3>
        <div className="grid md:grid-cols-2 gap-1">
          {tokens.map(t => (
            <div key={t.key} className="text-xs"><span className="font-mono text-blue-700">{`{${t.key}}`}</span> <span className="text-slate-600">{t.values}</span> <span className="text-slate-400">· {t.source}</span></div>
          ))}
        </div>
      </div>
    </div>
  );
};
